import BenefitItem from "./components/benefit-items";
import FeatureCard from "./components/feature-card";

export default function AIbasedContent() {
  return (
    <main className="px-6 sm:px-4 py-12 md:py-8 sm:py-6">
      <section className="mx-auto max-w-5xl text-center">
        <h1 className="text-balance text-5xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]">
          {"AI-Based Support – 24/7 AI Support"}
        </h1>
        <p className="mx-auto max-w-3xl mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium">
          {
            "Deliver 24/7 AI-driven support for queries, updates, and concerns while offering personalized learning resources tailored to each user. Continuously analyze interactions to optimize engagement, communication, and overall user experience—helping students, parents, and staff achieve more with less effort."
          }
        </p>
      </section>

      <section className="mx-auto mt-20 md:mt-12 sm:mt-8 grid max-w-6xl gap-4 md:gap-4 sm:gap-3 grid-cols-3 md:grid-cols-2 sm:grid-cols-1">
        <FeatureCard
          icon="shield"
          title="Record and Report"
          description="Easily report any issue directly from the dashboard. Hit the Record button which screengrabs your concern, and send—it reaches the relevant department instantly for the fastest possible resolution."
        />
        <FeatureCard
          icon="heartPulse"
          title="Self-Healing Feature"
          description="Our intelligent, regenerative app detects, resolves, and reports issues automatically, keeping your system problem-free and minimizing downtime."
        />
        <FeatureCard
          icon="userSquare"
          title="Virtual Relationship Manager"
          description="A dedicated Virtual Relationship Manager guides you through onboarding, ensuring seamless setup in under 10 minutes and helping you get started with zero friction."
        />
      </section>

      <section className="mx-auto mt-12 md:mt-10 sm:mt-8 max-w-6xl">
        <h2 className="text-2xl md:text-xl sm:text-lg font-semibold tracking-tight">Benefits and Impact</h2>
        <ul className="mt-6 md:mt-5 sm:mt-4 space-y-4 sm:space-y-3">
          <BenefitItem>{"Immediate issue detection and resolution ensures uninterrupted workflow."}</BenefitItem>
          <BenefitItem>
            {"Proactive support reduces manual follow-ups, staff effort, and operational bottlenecks."}
          </BenefitItem>
          <BenefitItem>{"Personalized onboarding assistance guarantees a smooth and fast start."}</BenefitItem>
          <BenefitItem>
            {
              "Reduces retention costs: Fast, efficient issue resolution keeps staff, students, and parents engaged and satisfied."
            }
          </BenefitItem>
          <BenefitItem>
            {
              "More dependable than traditional agencies: Soomuch.ai combines AI-driven support with personalized assistance, delivering consistent, reliable, and high-quality performance."
            }
          </BenefitItem>
        </ul>
      </section>
    </main>
  );
}